var React = require('react');

function SdCard (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M112 160h48V64h-48zm80 0h48V64h-48zm80-96v96h48V64z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M320 0H128L0 128v320a64.06 64.06 0 0 0 64 64h256a64.06 64.06 0 0 0 64-64V64a64.06 64.06 0 0 0-64-64zM160 160h-48V64h48zm80 0h-48V64h48zm80 0h-48V64h48z","className":"fa-primary","key":2})]);
}

SdCard.defaultProps = {"viewBox":"0 0 384 512","className":"icon"};

module.exports = SdCard;

SdCard.default = SdCard;
